import { render, staticRenderFns } from "./ChatHideConfig.vue?vue&type=template&id=c1ff60e0&scoped=true"
import script from "./ChatHideConfig.vue?vue&type=script&lang=js"
export * from "./ChatHideConfig.vue?vue&type=script&lang=js"
import style0 from "./ChatHideConfig.vue?vue&type=style&index=0&id=c1ff60e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff60e0",
  null
  
)

export default component.exports